import { VAT_PRECOUNT_RULES } from "config/vatPrecountRules";
import { BeneficiaryVAT, TBeneficiaryPrecount } from "store/types";

/**
 * Returns the i18n warning key if the given VAT + precount combination is fiscally unusual
 * for the company's country, or null if the combination is valid.
 *
 * Usage: const warningKey = useVatPrecountWarning("GR", vatValue, precountValue);
 */
export const useVatPrecountWarning = (
    countryCode: string,
    vatValue: BeneficiaryVAT | undefined,
    precountValue: TBeneficiaryPrecount | undefined,
): string | null => {
    if (vatValue === undefined || precountValue === undefined) return null;

    const rules = VAT_PRECOUNT_RULES[countryCode];
    if (!rules) return null;

    const matched = rules.find(
        (rule) => rule.vatValues.includes(vatValue) && rule.precountValues.includes(precountValue),
    );

    return matched?.warningKey ?? null;
};
